import { getElMerkleProof } from "@services/index";
import { useElMerkleProofIndex } from "./useElMerkleProofIndex";
import { BigNumber } from "ethers";
import { useQuery } from "@tanstack/react-query";

export function getQueryKey(
  address: `0x${string}` | undefined,
  index: BigNumber
) {
  return ["el-merkle-proof", address, index];
}

export function useElMerkleProof(address: `0x${string}` | undefined) {
  const index = useElMerkleProofIndex();

  return useQuery({
    queryKey: getQueryKey(address, index as BigNumber),
    queryFn: async () => {
      // the query is enabled only when the address is defined,
      const res = await getElMerkleProof(address!, BigNumber.from(index));
      return res.data;
    },
    enabled: index !== undefined && address !== undefined,
  });
}
